export const getFormattedFontArray = (data) => {
    return Object.values(data)
        ?.flat()
        ?.map((value, index) => ({
            id: index,
            name: value,
            value: value,
        }));
};

// Formats json in format of PrimeVue TreeSelect
export const formatTreeData = (data) => {
    let resData = [];
    for (let item of data) {
        let nodeData = {
            key: item.id,
            label: item.name,
            children: item.children.length > 0 ? formatTreeData(item.children) : [],
        };
        resData.push(nodeData);
    }
    return resData;
};

export const getFlattenArray = (arr) => {
    const result = [];

    const flatten = (item) => {
        result.push(item);
        if (item.children && item.children.length > 0) {
            item.children.forEach(flatten);
            delete item.children;
        }
    };

    arr.forEach(flatten);

    return result;
};

export const getFormattedTreeTableArray = (data) => {
    let resData = [];
    for (let item of data) {
        let nodeData = {
            key: item.id,
            data: {
                id: item.id,
                name: item.name,
                type: item.type,
                // parent_id: item.parent_id,
            },
            children: item?.children?.length > 0 ? getFormattedTreeTableArray(item.children) : [],
        };
        resData.push(nodeData);
    }
    return resData;
};

export const groupAttributesByBlock = (data) => {
    let resData = [];
    // filter out blocks with no attributes
    const filteredData = data.filter((obj) => obj.attributes?.length > 0);

    for (let item of filteredData) {
        let nodeData = {
            label: item.name,
            code: item.code,
            items: item.attributes?.map((attribute) => {
                return {
                    id: attribute.id,
                    label: attribute.label,
                    code: attribute.code,
                };
            }),
        };
        resData.push(nodeData);
    }
    return resData;
};

export const addFullNameToUserArray = (data) => {
    if (data && data.length) {
        return data?.map((datum) => {
            return {
                ...datum,
                fullname: datum.name + ' ' + datum.surname,
            };
        });
    }
    return [];
};
